module.exports = __webpack_public_path__ + "static/media/the-robots-putting-food-on-the-table.c049f1f5.jpg";